export default __webpack_public_path__ + "static/media/arrow_after.e8709d73.svg";